import React from "react"
//import I18n from "i18n-js/index.js.erb"

class PortalReservationCheckinNavigation extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    var steps = this.props.steps.map((step) => {
      return (
        <li key={step} className={this.props.step == step ? 'active' : ''}>
          <a href="#" style={{cursor: 'default'}}>{I18n.t(step)}</a>
        </li>
      );
    });

    return (
      <div>
        <div className="steps">
          <ul className="nav nav-wizard">
            {steps}
          </ul>
        </div>
      </div>
    );
  } 
}

export default PortalReservationCheckinNavigation